/*
import {
  hf,
  hfDTM,
  hfXLS,
  ht,
  _cv_60___Mz,
  _cv_61___Mz,
} from 'lib';
*/
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as _cv_61___Mz from "./_cv_61___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as hfXLS from "./_hfXLS";

import * as icvI10___Mz from './icvI10___Mz';
import * as icvI1z___Mz from './icvI1z___Mz';

export const eptExlAsync = async (pz: { // 部屋別予約一覧
  _31r_fst: ht.n,
  yearMth: ht.s,
}) => { // 予約一覧

  const _fileName = `使用状況一覧_${pz.yearMth}_${hfDTM.f(hfDTM.getTdy(), 'YYYYMMDD')}.xlsx`;
  const _shtName = `${pz.yearMth}`;

  const _dates = hfDTM.cvtMthDates(pz.yearMth + '-01');

  const _i1zrs = await icvI1z___Mz.loadI1zrLsAsync({ // 予約
    _31r_fst: pz._31r_fst,
    yearMth: pz.yearMth,
    i1zrs1100iMnm: 80,
    lwrType: 1,
  });

  const _rsvz = {} as ht.dz; // reserve
  _i1zrs.map((_i1zrz: ht.dz) => {
    //hf.l(`icvI1z___EzE4 31: ${hf.s(_i1zrz)}`);
    const _i18rz = hf.get1(_i1zrz?.cldz?.i18rs, {});
    if (!_rsvz[_i1zrz.i1zrd3100s]) _rsvz[_i1zrz.i1zrd3100s] = {};
    _i1zrz.cldz.i1z1s?.map((_i1z1z: ht.dz) => {
      if (!_rsvz[_i1zrz.i1zrd3100s][_i1z1z.i1z1i10r1f]) _rsvz[_i1zrz.i1zrd3100s][_i1z1z.i1z1i10r1f] = {};
      _rsvz[_i1zrz.i1zrd3100s][_i1z1z.i1z1i10r1f][_i1z1z.i1z1i1111f] = _i18rz._pfx;
    })
  });
  //hf.l(`icvI1z___EzE4 41: ${hf.s(_rsvz)}`);

  const _i10rs = await icvI10___Mz.loadI10rLsAsync({ // 部屋・時間帯
    _31r_fst: pz._31r_fst,
    i10rt1100i: 10, // 単体部屋のみ
    lwrType: 1,
  });
  //hf.l(`icvI1z___EzE4 36: ${hf.s(_i10rs)}`);

  const __601s = await _cv_60___Mz.load_601AsAsync({ // 祝日
    yearMth: pz.yearMth,
  })
  //hf.l(`icvI1z___EzE4 44: ${hf.s(__601s)}`);

  const __611s = await _cv_61___Mz.load_611AsAsync({ // 休館日
    _31r_fst: pz._31r_fst,
    yearMth: pz.yearMth,
    cdn: 'true',
  })
  //hf.l(`icvI1z___EzE4 49: ${hf.s(__611s)}`);

  const _wbk = hfXLS.crtWbk();
  const _wst = hfXLS.addSht(_wbk, _shtName);

  const _cmnW = 5;
  const _rowH = 20;

  let _row = 0;

/*
  _row += 1;
  hfXLS.setH(_wst, _row, _rowH);
  hfXLS.setW(_wst, 1, _cmnW);
  hfXLS.setW(_wst, 2, _cmnW);
  hfXLS.setVle(_wst, _row, 1, '日付');
  hfXLS.setFont(_wst, _row, 1, {
    bold: true,
  });

  hfXLS.mrgCells(_wst, _row, 1, _row+1, 1);
  hfXLS.setAmt(_wst, _row, 1, { vertical: 'middle', horizontal: 'center', wrapText: false });
  hfXLS.setBdr(_wst, _row, 1, { 
    top: { style: 'thin', color: { argb: '000000' }},
    bottom: { style: 'thin', color: { argb: '000000' }},
    left: { style: 'thin', color: { argb: '000000' }},
    right: { style: 'thin', color: { argb: '000000' }},
  });
  hfXLS.setVle(_wst, _row, 2, '曜日');
  hfXLS.setFont(_wst, _row, 2, {
    bold: true,
  });
  hfXLS.mrgCells(_wst, _row, 2, _row+1, 2);
  hfXLS.setAmt(_wst, _row, 2, { vertical: 'middle', horizontal: 'center', wrapText: false });
  hfXLS.setBdr(_wst, _row, 2, { 
    top: { style: 'thin', color: { argb: '000000' }},
    bottom: { style: 'thin', color: { argb: '000000' }},
    left: { style: 'thin', color: { argb: '000000' }},
    right: { style: 'thin', color: { argb: '000000' }},
  });

  _row += 1;
  hfXLS.setH(_wst, _row, _rowH);
  let _cmn = 2;
  _i10rs.map((_i10rz: ht.dz, _idxI10rz: ht.n) => {
    const _cmnStt = _cmn + 1;
    const _i111s = hf.get1(_i10rz.cldz.i11rs, {})?.cldz?.i111s;
    _i111s.map((_i111z: ht.dz, _idxI111z: ht.n) => {
      _cmn += 1;
      hfXLS.setW(_wst, _cmn, _cmnW * 2.5);
      hfXLS.setVle(_wst, _row, _cmn, _i111z._pfx);
      hfXLS.setFont(_wst, _row, _cmn, {
        bold: true,
      });
      hfXLS.setAmt(_wst, _row, _cmn, { vertical: 'middle', horizontal: 'center', wrapText: false });
      hfXLS.setBdr(_wst, _row, _cmn, { 
        top: { style: 'thin', color: { argb: '000000' }},
        bottom: { style: 'thin', color: { argb: '000000' }},
        left: { style: 'thin', color: { argb: '000000' }},
        right: { style: 'thin', color: { argb: '000000' }},
      });
    })
    hfXLS.setVle(_wst, _row-1, _cmnStt, _i10rz._pfx);
    hfXLS.setFont(_wst, _row-1, _cmnStt, {
      bold: true,
    });
    hfXLS.mrgCells(_wst, _row-1, _cmnStt, _row-1, _cmn);
    hfXLS.setAmt(_wst, _row-1, _cmnStt, { vertical: 'middle', horizontal: 'center', wrapText: false });
    hfXLS.setBdr(_wst, _row-1, _cmnStt, { 
      top: { style: 'thin', color: { argb: '000000' }},
      bottom: { style: 'thin', color: { argb: '000000' }},
      left: { style: 'thin', color: { argb: '000000' }},
      right: { style: 'thin', color: { argb: '000000' }},
    });
   });
*/
  _row += 1;
  hfXLS.setH(_wst, _row, _rowH);

  let _cmn = 0;
  _i10rs.map((_i10rz: ht.dz, _idxI10rz: ht.n) => {

    if ( _idxI10rz == 0 ) { // 最初と最後のみ
      _cmn += 1;
      hfXLS.setW(_wst, _cmn, _cmnW);
      hfXLS.setVle(_wst, _row, _cmn, '日付');
      hfXLS.setFont(_wst, _row, _cmn, { bold: true });
      hfXLS.mrgCells(_wst, _row, _cmn, _row+1, _cmn);
      hfXLS.setAmt(_wst, _row, _cmn, {
        textRotation: 'vertical'
      });
      hfXLS.setBdr(_wst, _row, _cmn, {});

      _cmn += 1;
      hfXLS.setW(_wst, _cmn, _cmnW);
      hfXLS.setVle(_wst, _row, _cmn, '曜日');
      hfXLS.setFont(_wst, _row, _cmn, { bold: true });
      hfXLS.mrgCells(_wst, _row, _cmn, _row+1, _cmn);
      hfXLS.setAmt(_wst, _row, _cmn, {
        textRotation: 'vertical'
      });
      hfXLS.setBdr(_wst, _row, _cmn, {});
    }

    const _cmnStt = _cmn + 1;
    const _i111s = hf.get1(_i10rz.cldz.i11rs, {})?.cldz?.i111s;
    _i111s.map((_i111z: ht.dz, _idxI111z: ht.n) => {
      _cmn += 1;
      hfXLS.setW(_wst, _cmn, _cmnW * 2.5);
      hfXLS.setVle(_wst, _row+1, _cmn, _i111z._pfx);
      hfXLS.setFont(_wst, _row+1, _cmn, { bold: true });
      hfXLS.setAmt(_wst, _row+1, _cmn, {});
      hfXLS.setBdr(_wst, _row+1, _cmn, {});
    })
    hfXLS.setVle(_wst, _row, _cmnStt, _i10rz._pfx);
    hfXLS.setFont(_wst, _row, _cmnStt, { bold: true });
    hfXLS.mrgCells(_wst, _row, _cmnStt, _row, _cmn);
    hfXLS.setAmt(_wst, _row, _cmnStt, {});
    hfXLS.setBdr(_wst, _row, _cmnStt, {});

    if ( _idxI10rz == _i10rs.length - 1 ) { // 最初と最後のみ
      _cmn += 1;
      hfXLS.setW(_wst, _cmn, _cmnW);
      hfXLS.setVle(_wst, _row, _cmn, '日付');
      hfXLS.setFont(_wst, _row, _cmn, { bold: true });
      hfXLS.mrgCells(_wst, _row, _cmn, _row+1, _cmn);
      hfXLS.setAmt(_wst, _row, _cmn, {
        textRotation: 'vertical'
      });
      hfXLS.setBdr(_wst, _row, _cmn, {});

      _cmn += 1;
      hfXLS.setW(_wst, _cmn, _cmnW);
      hfXLS.setVle(_wst, _row, _cmn, '曜日');
      hfXLS.setFont(_wst, _row, _cmn, { bold: true });
      hfXLS.mrgCells(_wst, _row, _cmn, _row+1, _cmn);
      hfXLS.setAmt(_wst, _row, _cmn, {
        textRotation: 'vertical'
      });
      hfXLS.setBdr(_wst, _row, _cmn, {});
    }

  });

  _row += 1;
  hfXLS.setH(_wst, _row+1, _rowH);

  _dates.map((_date: ht.s) => {

    const _argb = 
      (hf.i(_date, __611s)) ? // 休館日
        'aaaaaa'
      : (hfDTM.cvtDow(_date) == '土') ? // 土曜
        '87cefa' 
      : (hfDTM.cvtDow(_date) == '日' || hf.i(_date, __601s)) ? // 日・祝
        'ffb6c1'
      : 'ffffff'; 

    _row += 1;
    hfXLS.setH(_wst, _row, _rowH);

    _cmn = 0;

    _i10rs.map((_i10rz: ht.dz, _idxI10rz: ht.n) => {

      if ( _idxI10rz == 0 ) { // 最初と最後のみ
        _cmn += 1;
        hfXLS.setVle(_wst, _row, _cmn, hfDTM.cvtDay(_date));
        hfXLS.setAmt(_wst, _row, _cmn, {});
        hfXLS.setBdr(_wst, _row, _cmn, {});
        hfXLS.setFont(_wst, _row, _cmn, {});
        hfXLS.setScnClr(_wst, _row, _cmn, {
          fgColor: { argb:_argb }
        });

        _cmn += 1;
        hfXLS.setVle(_wst, _row, _cmn, hfDTM.cvtDow(_date));
        hfXLS.setAmt(_wst, _row, _cmn, {});
        hfXLS.setBdr(_wst, _row, _cmn, {});
        hfXLS.setFont(_wst, _row, _cmn, {});
        hfXLS.setScnClr(_wst, _row, _cmn, {
          fgColor: { argb:_argb }
        });
      }

      if ( hf.i(_date, __611s) ) { // 休館日
        const _cmnStt = _cmn + 1;
        const _i111s = hf.get1(_i10rz.cldz.i11rs, {})?.cldz?.i111s;
        _cmn += _i111s.length;
        hfXLS.setVle(_wst, _row, _cmnStt, '休館日');
        hfXLS.setFont(_wst, _row, _cmnStt, {
          bold: true,
          color: {
            argb: 'ff0000',
          },
        });
        hfXLS.mrgCells(_wst, _row, _cmnStt, _row, _cmn);
        hfXLS.setAmt(_wst, _row, _cmnStt, {});
        hfXLS.setBdr(_wst, _row, _cmnStt, {});
        hfXLS.setScnClr(_wst, _row, _cmnStt, { fgColor: { argb:_argb } });
      }
      else { // 休館日以外
        const _i111s = hf.get1(_i10rz.cldz.i11rs, {})?.cldz?.i111s;
        _i111s.map((_i111z: ht.dz, _idxI111z: ht.n) => {
          _cmn += 1;
          hfXLS.setVle(_wst, _row, _cmn, _rsvz[_date]?.[_i10rz._fst]?.[_i111z._fst] ?? '');
          hfXLS.setAmt(_wst, _row, _cmn, {
            shrinkToFit: true,
          });
          hfXLS.setBdr(_wst, _row, _cmn, {});
          hfXLS.setFont(_wst, _row, _cmn, {});
          hfXLS.setScnClr(_wst, _row, _cmn, { fgColor: { argb:_argb } });
        })
      }

      if ( _idxI10rz == _i10rs.length - 1 ) { // 最初と最後のみ
        _cmn += 1;
        hfXLS.setVle(_wst, _row, _cmn, hfDTM.cvtDay(_date));
        hfXLS.setAmt(_wst, _row, _cmn, {});
        hfXLS.setBdr(_wst, _row, _cmn, {});
        hfXLS.setFont(_wst, _row, _cmn, {});
        hfXLS.setScnClr(_wst, _row, _cmn, {
          fgColor: { argb:_argb }
        });

        _cmn += 1;
        hfXLS.setVle(_wst, _row, _cmn, hfDTM.cvtDow(_date));
        hfXLS.setAmt(_wst, _row, _cmn, {});
        hfXLS.setBdr(_wst, _row, _cmn, {});
        hfXLS.setFont(_wst, _row, _cmn, {});
        hfXLS.setScnClr(_wst, _row, _cmn, {
          fgColor: { argb:_argb }
        });
      }

    });

  })

  hfXLS.dldWbkAsync(_wbk, _fileName);

/*
  const _hdrs = [
    { key: 1100, header: 'No', width: 5, style: {} },
    { key: 1200, header: '予約ID', width: 5, style: {} },
    { key: 1300, header: '状況', width: 5, style: {} },
    { key: 1400, header: '団体番号', width: 5, style: {} },
    { key: 1500, header: '団体名', width: 20, style: {} },
    { key: 1600, header: '利用日', width: 10, style: {} },
    { key: 1700, header: '利用部屋', width: 20, style: {} },
    { key: 1800, header: '利用時間帯', width: 20, style: {} },
    { key: 1900, header: '利用料', width: 10, style: {} },
    { key: 2000, header: '利用料受領日', width: 10, style: {} },
    { key: 2100, header: '目的', width: 20, style: {} },
    { key: 2200, header: '備考', width: 20, style: {} },
  ];

  let _bdys = [] as ht.ls;
  _i1zrs.filter((_i1zrz: ht.dz) => (
    (pz.ctt == 'r' && _i1zrz.i1zrs1100i >= 80) || 
    (pz.ctt == 'e' && _i1zrz.i1zrs1200i >= 70)
  )).map((_i1zrz: ht.dz, _i1zrIdx: ht.n) => {
    const _i18rz = hf.get1(_i1zrz?.cldz?.i18rs, {});
    //hf.l(`icvI1z___Ez 395: ${hf.s(_i18rz)}`)
    const _i1z3z = hf.get1(_i1zrz?.cldz?.i1z3s, {});
    _bdys.push({
      1100: _i1zrIdx + 1,
      1200: _i1zrz._icn,
      1300: 
        pz.ctt == 'r' ? 
          ihd.r(ihd.f('i1zrs1100i').ls, _i1zrz.i1zrs1100i)
        : pz.ctt == 'e' ? 
          ihd.r(ihd.f('i1zrs1200i').ls, _i1zrz.i1zrs1200i)
        : '',
      1400: _i18rz.i18rab100s,
      1500: _i18rz._pfx,
      1600: hfDTM.f(_i1zrz.i1zrd3100s, '年月日曜'),
      1700: _i1zrz.i1zra1100s,
      1800: _i1zrz.i1zra1200s,
      1900: _i1z3z.i1z3m1110i,
      2000: _i1z3z.i1z3d2100s,
      2100: _i1zrz.i1zra4100s,
      2200: _i1zrz._ctn,
    });
  });

  hfXLS.saveAsync({
    fileName: _fileName,
    shts: [
      {
        shtName: _shtName,
        hdrs: _hdrs,
        bdys: _bdys,
      }
    ]
  })
*/

};
